import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-type-float",
  "use": "icon-type-float-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-type-float\"><path d=\"M5.656 4q.562.039.953.485.39.449.391 1.122v1.608q0 .672-.391 1.12-.39.45-.953.449H4.344V10.5H7V12H3V8.784q0-.672.391-1.12t.953-.448h1.313V5.5H3V4zM13 4v8h-1.343V5.5h-1.345V4zm-4.5 6.5H10V12H8.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol